function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// TODO replace this by supported breakpoints
const deprecatedBreakpoints = {
  giant: 1170
};
const breakpoints = _objectSpread(_objectSpread({}, deprecatedBreakpoints), {}, {
  desktop_small: 1280,
  tablet: 1040,
  phone: 768,
  phone_small: 560
});
function rangeUpTo(to) {
  return `max-width: ${to}px`;
}
function rangeStartingFrom(from) {
  return `min-width: ${from + 1}px`;
}
function rangeInBetween(from, to) {
  return `min-width: ${from + 1}px) and (max-width: ${to}px`;
}
const devices = {
  // Main devices
  phone: rangeUpTo(breakpoints.phone),
  tablet: rangeInBetween(breakpoints.phone, breakpoints.tablet),
  desktop: rangeStartingFrom(breakpoints.tablet),
  // Picky devices
  phone_small: rangeUpTo(breakpoints.phone_small),
  phone_large: rangeInBetween(breakpoints.phone_small, breakpoints.phone),
  desktop_small: rangeInBetween(breakpoints.tablet, breakpoints.desktop_small),
  desktop_large: rangeStartingFrom(breakpoints.desktop_small),
  // Deprecated devices
  deprecated_tablet: rangeInBetween(breakpoints.phone, deprecatedBreakpoints.giant),
  deprecated_desktop_small: rangeInBetween(breakpoints.phone, deprecatedBreakpoints.giant),
  deprecated_desktop_large: rangeStartingFrom(deprecatedBreakpoints.giant)
};
export { breakpoints, devices as default };
//# sourceMappingURL=devices.js.map
